export class StringUtil {
  public static get EMPTY(): string { return '';}
}